import { useTracking } from 'react-tracking';

import { Modal } from '@simplywallst/ui-core';

import type { Watchlist } from '@/hooks/useWatchlist';
import useWatchlistMutations from '../../hooks/useWatchlistMutations';

interface Props {
  onClose: () => void;
  onDelete?: () => void;
  watchlist: Watchlist;
}

const DeleteWatchlistModal = ({ onClose, onDelete, watchlist }: Props) => {
  const { trackEvent } = useTracking();
  const { deleteWatchlist } = useWatchlistMutations();

  const handleDelete = () => {
    trackEvent({
      action: 'click',
      modifier: 'deleteWatchlist',
    });
    deleteWatchlist(watchlist);
    onDelete && onDelete();
  };

  return (
    <Modal
      title="Delete List"
      asForm={true}
      onSecondaryClick={onClose}
      onPrimaryClick={handleDelete}
      secondaryLabel="Cancel"
      primaryLabel="Yes, delete"
    >
      {`Do you really want to delete '${watchlist.name}'?`}
    </Modal>
  );
};

export default DeleteWatchlistModal;
